import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import PosSystemService, { IssueResponse } from '../../services/PosSystemService';

type Props = {
    isModalOpen: boolean;
    issueResponse: IssueResponse;
    cashBoxId: string;
    accessToken: string;
    onCloseModal: () => void;
}

const SmsModal: React.FC<Props> = (props) => {
    const [sms, setSMS] = useState<string>();

    useEffect(() => {
        setSMS("");
    }, [props.isModalOpen])

    return (
        <Modal show={props.isModalOpen} centered>
            <Modal.Header>
                <Modal.Title>Send by SMS</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Label htmlFor="sms">Please enter your phone number:</Form.Label>
                <Form.Control
                    type="text"
                    value={sms}
                    onChange={(event) => setSMS(event.currentTarget.value)}
                    id="sms"
                    aria-describedby="sms"
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => props.onCloseModal()}> Cancel</Button>
                <Button variant="primary" className='btn-primary' onClick={async () => {
                    if (sms) {
                        await PosSystemService.SendViaSmsAsync(props.issueResponse, sms, props.cashBoxId, props.accessToken);
                    }
                    props.onCloseModal();
                }}> Send</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SmsModal;